import { useEffect, useState } from 'react'

import type { Dispatch, SetStateAction } from 'react'

const useTouchDown = (touch: string): { isTouchDown: boolean; setIsTouchDown: Dispatch<SetStateAction<boolean>> } => {
  const [isTouchDown, setIsTouchDown] = useState(false)

  useEffect(() => {
    document.addEventListener('keydown', (e) => setIsTouchDown(e.key === touch))
    document.addEventListener('keyup', () => setIsTouchDown(false))

    return () => {
      document.removeEventListener('keydown', (e) => setIsTouchDown(e.key === touch))
      document.removeEventListener('keyup', () => setIsTouchDown(false))
    }
  }, [touch])

  return { isTouchDown, setIsTouchDown }
}

export { useTouchDown }
